export default __webpack_public_path__ + "static/media/Silent Mist.c7d907ea.png";